import { render, staticRenderFns } from "./YoutubeField.vue?vue&type=template&id=4edfa4be&scoped=true"
import script from "./YoutubeField.vue?vue&type=script&lang=js"
export * from "./YoutubeField.vue?vue&type=script&lang=js"
import style0 from "./YoutubeField.vue?vue&type=style&index=0&id=4edfa4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edfa4be",
  null
  
)

export default component.exports